<template>
  <div>
    <el-timeline-item
      v-if="content"
      :icon="icon"
      :type="type"
      :color="color"
      size="large"
      :timestamp="formatDate(activity.createdOn)"
    >
      <div v-html="formattedActivityText" class=""></div>
    </el-timeline-item>
  </div>
</template>

<script>
import ActivitiesTimelineMixin from "@/components/ActivitiesView/ActivitiesTimelineMixin.vue";
export default {
  mixins: [ActivitiesTimelineMixin],
  props: {
    activity: {
      type: Object,
      required: true
    },
    WatercraftType: {
      type: Object,
      required: false
    }
  },
  methods: {
    async generateReadableUpdateWatercraftType() {
      let contentHtml = ``;
      for (let update of this.updates) {
        contentHtml = this.generateRegularActivityString(contentHtml, update);
      }
      this.setReadableUpdateProps(contentHtml);
    }
  },
  watch: {
    activity: {
      async handler() {
        this.content = "";
        this.icon = "";
        this.type = "";
        this.link = {};
        this.color = "";
        switch (this.activity.name) {
          case "ADD_WATERCRAFT_TYPE_SUCCESS":
            this.generateReadableGeneric({
              content: "added a new watercraft type.",
              icon: "el-icon-document",
              type: "success",
              link: this.accountTypeFormatted
            });
            break;
          case "ADD_WATERCRAFT_TYPE_FAILURE":
            this.generateReadableFailGeneric({
              content: "failed to add a new watercraft type.",
              icon: "el-icon-document",
              link: this.accountTypeFormatted
            });
            break;
          case "UPDATE_WATERCRAFT_TYPE_SUCCESS":
            await this.generateReadableUpdateWatercraftType();
            break;
          case "UPDATE_WATERCRAFT_TYPE_FAILURE":
            this.generateReadableFailGeneric({
              content: "failed to update watercraft type.",
              icon: "el-icon-document",
              link: this.accountTypeFormatted
            });
            break;
          case "DELETE_WATERCRAFT_TYPE_SUCCESS":
            this.generateReadableGeneric({
              content: "deleted a watercraft type.",
              icon: "el-icon-document",
              type: "success",
              link: this.accountTypeFormatted
            });
            break;
          case "DELETE_WATERCRAFT_TYPE_FAILURE":
            this.generateReadableFailGeneric({
              content: "failed to delete watercraft type.",
              icon: "el-icon-document",
              link: this.accountTypeFormatted
            });
            break;
          case "BULK_DELETE_WATERCRAFT_TYPE_SUCCESS":
            this.generateReadableGeneric({
              content: this.bulkDeletionWording,
              icon: "el-icon-document",
              type: "success",
              link: this.accountTypeFormatted
            });
            break;
          case "BULK_DELETE_WATERCRAFT_TYPE_FAILURE":
            this.generateReadableFailGeneric({
              content: this.bulkDeletionWording,
              icon: "el-icon-document",
              link: this.accountTypeFormatted
            });
            break;
          case "BULK_RESTORE_WATERCRAFT_TYPE_SUCCESS":
            this.generateReadableGeneric({
              content: this.bulkRestorationWording,
              icon: "el-icon-document",
              type: "success",
              link: this.accountTypeFormatted
            });
            break;
          case "BULK_RESTORE_WATERCRAFT_TYPE_FAILURE":
            this.generateReadableFailGeneric({
              content: this.bulkRestorationWording,
              icon: "el-icon-document",
              link: this.accountTypeFormatted
            });
            break;
        }
      },
      immediate: true
    }
  },
  computed: {
    bulkDeletionWording() {
      const count = this?.activity?.data?.watercraftTypeIds?.length || 0;
      return count > 1
        ? `deleted ${count} watercraft types.`
        : `deleted 1 watercraft type.`;
    },
    bulkRestorationWording() {
      const count = this?.activity?.data?.watercraftTypeIds?.length || 0;
      return count > 1
        ? `restored ${count} watercraft types.`
        : `restored 1 watercraft type.`;
    }
  }
};
</script>

<style></style>
